import { Effects as PortfolioEffects } from "@/store/portfolio/effects";
import { Actions as PortfolioActions } from "@/store/portfolio/slice";
import { Effects as FavEffects } from "@/store/favorites/effects";
import { Selectors as PortfolioSelectors } from "@/store/portfolio/selectors";
import { Selectors as FavSelectors } from "@/store/favorites/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Selectors } from "./selectors";
import { UserAPI } from "@/api/user";
import { Actions } from "./slice";
import { CommentsAPI } from "@/api/comments";
import pick from "lodash/pick";

const getCommentTypeFromEntity = (type) => {
  if (type === "Review") {
    return "review";
  }
};
const openGallery = (portfolioId) => (dispatch, getState) => {
  const idx = PortfolioSelectors.getPortfolio(getState()).findIndex(
    ({ _id }) => _id === portfolioId
  );
  if (idx !== -1) {
    dispatch(PortfolioActions.openGallery(idx));
  }
};
const toggleLike = (id, type) => (dispatch, getState) => {
  if (type === "Portfolio") {
    dispatch(PortfolioEffects.toggleLike(id));
  } else if (type === "Review") {
    const isFav = FavSelectors.isFavorite(getState(), "reviews", id);
    dispatch(FavEffects.toggleFavorite("reviews", id));
    if (isFav) {
      dispatch(Actions.removeLike({ id, entity: "Review" }));
    } else {
      dispatch(Actions.addLike({ id, entity: "Review" }));
    }
  }
};
const loadComments = (id, type) => async (dispatch) => {
  const commentType = getCommentTypeFromEntity(type);
  const { data } = await CommentsAPI.getComments(commentType, id);
  dispatch(Actions.setComments({ comments: data, id, entity: type }));
};
const addComment = (id, type, payload) => async (dispatch, getState) => {
  const commentType = getCommentTypeFromEntity(type);
  const { data } = await CommentsAPI.createComment(commentType, id, payload);
  const user = UserSelectors.getProfile(getState());
  const normComment = {
    ...data,
    author: {
      ...pick(user, [
        "first_name",
        "last_name",
        "_id",
        "sex",
        "avatar",
        "online",
      ]),
      master: user?.master?._id,
    },
  };
  dispatch(
    Actions.addComment({
      id,
      entity: type,
      payload: normComment,
    })
  );
};
const removeComment = (id, commentId, type) => async (dispatch) => {
  const commentType = getCommentTypeFromEntity(type);
  await CommentsAPI.deleteComment(commentType, id, commentId);
  dispatch(Actions.removeComment({ id, entity: type, commentId }));
};
const loadFeed = () => async (dispatch, getState) => {
  const last = Selectors.getLastActivity(getState());
  if (last) {
    try {
      dispatch(Actions.loadFeedStart());
      const { data } = await UserAPI.getFeed(last.actor, {
        last: last.date,
      });
      dispatch(Actions.loadFeedSuccess(data));
    } catch (e) {
      dispatch(Actions.loadFeedError(e));
    }
  }
};
export const Effects = {
  addComment,
  removeComment,
  loadComments,
  toggleLike,
  openGallery,
  loadFeed,
};
